import { useState } from "react";
import { Container } from "~/components/Container";
import { Flex } from "~/components/Flex";
import { Label } from "~/components/Typography";
import {
  createQuickAgencyActions,
  createQuickAgencyConfigurationActions,
  createQuickConfigurationActions,
  createQuickOptionsActions,
} from "./utils";
import { QuickActionsScroller } from "~/core/shared/BookingMenuLayout/components/QuickActionsScroller";
import { Col } from "~/components/Grid";
import { useNavigate } from "react-router-dom";
import { Icon } from "~/components/Icon";
import SvgQuestionMark from "~/components/Icon/icons/QuestionMark";
import { Text } from "~/components/Text";
import { SvgChevronDown } from "~/components/Icon/icons";
import { DropdownCollapse } from "~/components/Collapse/Collapse";
import { SearchBar } from "~/components/Input";
import { useUser } from "~/presentation/core/contexts/UserContext";

export const OptionsMenuContainer = () => {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { contexts } = useUser();

  const isAgency = !!contexts?.agency?.uuid;

  const handleSearch = (term: string) => {
    setSearchTerm(term);
  };

  const quickActions = createQuickOptionsActions({ navigate });
  const quickConfigurationActions = createQuickConfigurationActions({ navigate });

  const filteredQuickActionsCustomer = quickActions.filter((action) =>
    action.label.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  const filteredQuickCustomerConfigurationActions = quickConfigurationActions.filter((action) =>
    action.label.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const agenyConfigurationActions = createQuickAgencyConfigurationActions({ navigate });
  const filteredAgencyConfigurationActions = agenyConfigurationActions.filter((action) =>
    action.label.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const agencyQuickActions = createQuickAgencyActions({ navigate });

  const filteredAgencyQuickActions = agencyQuickActions.filter((action) =>
    action.label.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const faqs = [
    {
      question: "É possível adicionar diferentes tipos de despesas a um mesmo projeto?",
      answer: "Sim, é possível adicionar diferentes tipos de despesas a um mesmo projeto...",
    },
    {
      question: "Como posso visualizar o histórico de despesas cadastradas?",
      answer:
        "Você pode visualizar o histórico acessando o menu 'Relatórios' e filtrando por data...",
    },
    {
      question: "Quais são as categorias de despesas disponíveis no sistema?",
      answer:
        "As categorias disponíveis incluem alimentação, transporte, hospedagem, entre outras...",
    },
  ];

  const toggleIndex = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Col css={{ background: "#CCE3FD", width: "100%", pt: "0px", "@mxlg": { pt: "60px" } }}>
        <Flex css={{ width: "100%", p: "$3" }}>
          <SearchBar
            css={{ width: "100%" }}
            search={searchTerm}
            onSearchChange={handleSearch}
            placeholder="Buscar ações..."
          />
        </Flex>
      </Col>
      <Container css={{ px: "$4", py: "$6", overflow: "hidden" }}>
        <Flex direction="column" css={{ gap: "$6" }}>
          <Col css={{ gap: "$4" }}>
            <Label>Ações rápidas</Label>
            <Flex direction="column" css={{ mx: "-$4" }}>
              <QuickActionsScroller
                edgeMargin="$4"
                actions={isAgency ? filteredAgencyQuickActions : filteredQuickActionsCustomer}
              />
            </Flex>
          </Col>
          <Col>
            <Label>Configurações</Label>
            <Flex direction="column" css={{ mx: "-$4" }}>
              <QuickActionsScroller
                edgeMargin="$4"
                actions={
                  isAgency
                    ? filteredAgencyConfigurationActions
                    : filteredQuickCustomerConfigurationActions
                }
              />
            </Flex>
          </Col>
        </Flex>

        <Flex gap="3" direction="column" css={{ mt: "$5", display: "none" }}>
          <Label>Perguntas frequentes</Label>

          {faqs.map((faq, index) => (
            <div key={index}>
              <Flex
                align="center"
                justify="between"
                css={{ py: "$2", cursor: "pointer" }}
                onClick={() => toggleIndex(index)}
              >
                <Icon as={SvgQuestionMark} css={{ color: "$primary-base", flexShrink: 0 }} />

                <Text
                  css={{
                    flex: 1,
                    mx: "$2",
                    fontWeight: "$bold",
                    color: "$primary-base",
                    lineHeight: "1.4",
                  }}
                >
                  {faq.question}
                </Text>

                <Icon
                  as={SvgChevronDown}
                  css={{
                    flexShrink: 0,
                    transform: openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                  }}
                />
              </Flex>

              <DropdownCollapse isOpened={openIndex === index}>
                <Col css={{ px: "$6", py: "$2" }}>
                  <Text>{faq.answer}</Text>
                </Col>
              </DropdownCollapse>
            </div>
          ))}
        </Flex>
      </Container>
    </>
  );
};
